/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {EmailSenderComponent as ɵb} from './email-sender.component';
export {declaration as ɵa} from './email-sender.module';
export {EmailSenderRoutes as ɵd} from './email-sender.routing';
export {TestEmailSenderComponent as ɵc} from './test-email-sender/test-email-sender.component';